<template>
  <div class="card h-100">
    <div class="card-body">
      <p class="mb-3">
        <small class="font-weight-bold">Risk</small>
      </p>

      <div class="risk-bars">
        <div
          v-for="item in normalized"
          :key="item.label"
          class="risk-col"
        >
          <div class="risk-value text-muted">
            {{ item.value }}
          </div>
          <div class="risk-track">
            <div
              class="risk-fill"
              :style="{ height: `${item.percent}%`, backgroundColor: item.color }"
            />
          </div>
          <div class="risk-label text-muted">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },

  computed: {
    maxValue () {
      return Math.max(1, ...this.items.map(i => Number(i.value) || 0))
    },
    normalized () {
      return this.items.map(item => {
        const value = Number(item.value) || 0
        const percent = Math.round((value / this.maxValue) * 100)
        return {
          label: item.label,
          value,
          color: item.color,
          percent
        }
      })
    }
  }
}
</script>

<style scoped>
.risk-bars {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}

.risk-col {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 28%;
}

.risk-value {
  font-size: 12px;
  margin-bottom: 10px;
}

.risk-track {
  background: #dedede;
  border-radius: 10px;
  height: 220px;
  overflow: hidden;
  position: relative;
  width: 12px;
}

.risk-fill {
  bottom: 0;
  border-radius: 10px;
  position: absolute;
  width: 100%;
}

.risk-label {
  font-size: 12px;
  margin-top: 10px;
}
</style>
